import { observer } from 'mobx-react';
import React from 'react';
import { useAnalytics } from '../../../app/data/AnalyticsProvider';
import { useStore } from '../../../app/data/root.store';
import { QuestionnaireBackButtonWrapper, QuestionnaireTitleWrapper } from '../../../onboarding/components/Questionnaire/OnBoardingQuestionnaire.styles';
import { AdamImageComponent } from '../../../user-activation-flow/components/steps/MeetAdamStep';
import { AUTH_STEPS } from '../../../user/data/user.store';
import { GreetingStepHeader, GreetingStepSubHeader, LoginFormButton, StyledGreetingStepWrapper } from '../LoginPage.styles';
import { ReactComponent as BackArrowIcon } from '../../../onboarding/assets/back-arrow-icon.svg';
import { CountAnimation } from '../../../../common/components/count-animation/CountAnimation';
import { useTrackEvent } from '../../../../hooks/useTrackEvent/useTrackEvent';
export const GreetingStep = observer(() => {
  const { userStore } = useStore();
  const { trackEvent } = useAnalytics();

  const handleContinue = () => {
    trackEvent('Questionnaire Step Completed', {
      step_name: 'greeting_step',
      step_flow: 'b2c',
      location: 'pre_signup',
    });
    userStore.setAuthStep(AUTH_STEPS.SIGN_UP_STEP);
  };

  const handleBackClick = () => {
    userStore.setAuthStep(AUTH_STEPS.WEALTH_MANAGEMENT_TYPE_STEP);
  };

  useTrackEvent('Questionnaire Step Viewed', {
    step_name: 'greeting_step',
    location: 'pre_signup',
    step_flow: 'b2c',
  });

  return (
    <>
      <QuestionnaireBackButtonWrapper onClick={handleBackClick} style={{ alignSelf: 'flex-start', paddingLeft: '4px', marginBottom: '20px' }}>
        <BackArrowIcon />Back
      </QuestionnaireBackButtonWrapper>
      <StyledGreetingStepWrapper>
        <QuestionnaireTitleWrapper style={{ marginBottom: '8px' }}>
          <AdamImageComponent size={48} />
        </QuestionnaireTitleWrapper>

        <GreetingStepHeader style={{ marginBottom: '8px' }}>You're in good hands!</GreetingStepHeader>
        <GreetingStepSubHeader>
          Vyzer helps <CountAnimation width={72} value={11868} duration={2} /> individuals like you effectively manage their wealth.
        </GreetingStepSubHeader>

        <LoginFormButton
          style={{ width: '320px', borderRadius: '50px', maxHeight: '56px' }}
          onClick={handleContinue}
        >
          Wow! Let's continue
        </LoginFormButton>
      </StyledGreetingStepWrapper>
    </>
  );
}); 